import   React,
       { useState, 
         useEffect, 
         useCallback        }   from "react";
import { useLoader          }   from "components/Covers/loadingCover";
import { useActionModal     }   from "components/Covers/confirmAction";
import { useInfoMsgModal    }   from "components/Covers/infoMessageModal";
import { useToastMessage    }   from "components/Covers/toastMessage";
import { InputGeneral       }   from "components/Field/field";
import   MainStyle              from "components/UI/main.module.scss";
import { getUserTag, 
         updateUserTag, 
         deleteUserTag      }   from "./userTagsService";
import { q3x_FunData, 
         DefaultLoadingLogo,
         GetLabel,
         SetLastFeature     }   from "Utilities/utils";
import { ChromePicker       }   from "react-color";

let blank_tag_obj = {
    IsEditing: true,
    IsLoading: false,
    TAG_ID:     0,
    TAG_POSITION: 0,
    TAG_DESC:   "",
    TAG_COLOR:  ""
};
let appLang = null;

const DefaultPadding = () =>{
    return(
        <>
            <div className={MainStyle.py_3}/>
        </>
    );
};

const Tag = React.memo(({ ...other}) => {
    const { tagColor } = other;
    return (
            <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 448 512"
                style={{ fill: tagColor, width: 'auto', height: '3.0rem' }}
            >
              <path d="M0 80L0 229.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0L418.7 317.3c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7L48 32C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/>
            </svg>
    );
});

const TagItem =  React.memo(({ prop, setProp, index, onDelete }) => {
    const { showInfoMessage   }                                 = useInfoMsgModal();                // Modal message control 
    const { showActionMessage }                                 = useActionModal();                 // Modal message + action control     
    const { showToastMessage  }                                 = useToastMessage();                // Toast message display

    const handleInputChange      = (field, value) => {
        setProp(index, { [field]: value });
    };

    const handleEdit             = () => {
        if (!prop.IsEditing) {
            handleInputChange("IsEditing", true);
        }
        else {
            handleInputChange("IsEditing", false);
            saveItem();
        }
    };

    const saveItem = async () => {
        if ( prop.TAG_DESC === "" ||  prop.TAG_COLOR === "") {
            showInfoMessage({header: GetLabel(appLang, 54), message: GetLabel(appLang, 60)});
            handleInputChange("IsEditing", true);
            return;
        }

        if (prop.TAG_ID === 0 ){
            let data = await updateUserTag(prop);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    handleInputChange("TAG_ID", parseInt(data.TAG_ID));
                    handleInputChange("IsLoading", false);
                    handleInputChange("IsEditing", false);
                }
                else {
                    handleInputChange("IsLoading", false);
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }
        }
        else {
            handleInputChange("IsLoading", true);
            let data = await updateUserTag(prop);
            if (data) {
                if (data?.status?.statusCode == 0) {
                    data = data.response.content;
                    handleInputChange("TAG_ID", parseInt(data.TAG_ID));
                    handleInputChange("IsLoading", false);
                    handleInputChange("IsEditing", false);
                }
                else {
                    handleInputChange("IsLoading", false);
                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                }
            }

        }
        
    };

    async function deleteItem (item_id, index) {
        if (item_id === 0 ){
            onDelete(item_id, index);
        }
        else {
            handleInputChange("IsLoading", true);
            let obj = {TAG_ID: item_id, DELETE_ALL: false};
            let data = await deleteUserTag(obj);
            if (data) {
                if (data?.status?.statusCode === 0) {
                    data = data.response.content;
                    handleInputChange("IsLoading", false);
                    onDelete(item_id, index);
                }
                else {
                    if (data?.status?.statusCode === -10) {
                        handleInputChange("IsLoading", false);
                        showActionMessage(
                            { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 370)}<br/>{GetLabel(appLang, 59)}</> },
                            { confirm_action: async () => {
                                obj.DELETE_ALL = true;                        
                                data = await deleteUserTag(obj);
                                handleInputChange("IsLoading", true);
                                if (data?.status?.statusCode === 0) {
                                    handleInputChange("IsLoading", false);
                                    onDelete(item_id, index);
                                }
                                else {
                                    handleInputChange("IsLoading", false);
                                    showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});                                    
                                }

                            }}
                        );
                    }
                    else {
                        handleInputChange("IsLoading", false);
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': data.status.message});
                    }
                }
            }
        }
    }
    
    const handleDelete = () => {
        if (prop.TAG_ID == 0) {
            deleteItem(prop.TAG_ID, index);
        }
        else {
            showActionMessage(
                { header: GetLabel(appLang, 54), message: <>{GetLabel(appLang, 58)}<br/>{GetLabel(appLang, 59)}</> },
                { confirm_action: () => deleteItem(prop.TAG_ID, index)}
            );
            return;
        }
    };
    return (
        <>
            <div className={[MainStyle.row, MainStyle.align_items_center, MainStyle.mx_3, MainStyle.py_1, MainStyle.bg_card_item, MainStyle.shadow_sm, MainStyle.border, MainStyle.rounded].join(" ")}>                
                    {/*         Loading Icon                */}
                    { prop.IsLoading && ( 
                            <div style={{zIndex: '1'}} className={[MainStyle.col_lg_1, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                <div className={[MainStyle.small_loading_circle].join(" ")}/>
                            </div>
                    )}
                    
                    {/*         Item Position               */}
                    <div className={[MainStyle.col_lg_1, MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <span className={[  
                                            MainStyle.fs_7,
                                            MainStyle.text_body,
                                            MainStyle.fw_semibold].join(" ")}>
                            { index  + 1 }
                        </span>                                
                    </div>
                    
                    {/*         Tag desc                    */}
                    <div className={[MainStyle.col_lg, MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            <span className={[  MainStyle.fs_6,
                                                MainStyle.text_body,
                                                MainStyle.fw_semibold].join(" ")}>
                                {GetLabel(appLang, 56)}
                            </span>
                            {
                                prop.IsEditing ?
                                    <InputGeneral 
                                        value={prop.TAG_DESC || ''}
                                        className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
                                        onChange={(event) => handleInputChange("TAG_DESC", q3x_FunData(event.target.value))}
                                        placeholder={GetLabel(appLang, 176)}
                                        maxLength={50}
                                    />
                                :
                                    <p className={[  MainStyle.fs_7, MainStyle.text_body].join(" ")}>        
                                        {prop.TAG_DESC || ''}
                                    </p>
                            }
                        </div>
                    </div>

                    {/*         Tag display                */}
                    <div className={[MainStyle.col_lg, MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            <Tag tagColor={prop.TAG_COLOR}/>
                        </div>                                                    
                    </div>
                    
                    {/*         Color Picker                */}                    
                    {prop.IsEditing && (
                        <div className={[MainStyle.col_lg, MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                            <ChromePicker
                                width={'99%'}
                                disableAlpha={true}
                                color={prop.TAG_COLOR}
                                presetColors={[]}
                                onChange={(color) => {
                                    handleInputChange("TAG_COLOR", color.hex);
                                }}
                            />
                        </div>
                    )}                

                    {/*         Ico Edit                    */}
                    <div className={[MainStyle.col_lg_1, MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            {
                                prop.IsEditing ? 
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {handleEdit();}}>
                                        <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
                                        </svg>
                                    </div>
                                :
                                    <div className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")} onClick={() => {handleEdit();}}>
                                        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                            <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"/>
                                        </svg>
                                    </div>
                            }
                        </div>
                    </div>
                    {/*         Ico Trash                   */}
                    <div className={[MainStyle.col_lg_1, MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                        <div className={MainStyle.m_2}>
                            <div 
                                onClick={() => {handleDelete()}}
                                className={[MainStyle.border, MainStyle.shadow_sm, MainStyle.rounded, MainStyle.table_btn_icon, MainStyle.text_center, MainStyle.p_1, MainStyle.ms_1].join(" ")}>
                                <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg" className={[MainStyle.small_ico_generic].join(" ")}>
                                    <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                                </svg>
                            </div>
                        </div>
                    </div>
            </div>
        </>
    );
});

const TagList = ({ mainObject, setMainObject }) => {

    const addNewItem    = () => {
        // Create a new object
        const newObject = {
            ...blank_tag_obj, // Copy the template            
            TAG_ID: 0,
            TAG_POSITION: mainObject.length + 1,
            TAG_DESC: "",
            TAG_COLOR: "",
            IsEditing: true,
        };
    
        // Update state correctly by creating a new array
        setMainObject(prevState => [...prevState, newObject]);
    };

    const setItem = useCallback((itemIndex, updatedFields) => {
        setMainObject(prev => {
            const newItems = [...prev];
            newItems[itemIndex] = {
                ...newItems[itemIndex],
                ...updatedFields,
            };
            return newItems;
        });
    }, []);

    function handleItemDelete(item_id, item_position) {
        if (item_id !== 0) {
            // Delete by ID
            setMainObject(prevState => {
                const updatedItems = prevState.filter(item => item.TAG_ID !== item_id);
    
                const reorderedItems = updatedItems.map((item, idx) => ({
                    ...item,
                    TAG_POSITION: idx,
                }));
    
                return reorderedItems;
            });
        } else {
            // Delete by position
            setMainObject(prevState => {
                const updatedItems = prevState.filter(item => item.TAG_POSITION -1 !== item_position);
    
                const reorderedItems = updatedItems.map((item, idx) => ({
                    ...item,
                    TAG_POSITION: idx,
                }));
                return reorderedItems;
            });
            reorderItems();
        }
    }
    
    function reorderItems () {
        setMainObject(prevState => {
            const reorderedItems = prevState.map((item, index) => ({
                ...item,
                TAG_POSITION: index + 1, // 0-based order now, matching array index
            }));
        
            return reorderedItems;
        });
    }

    const renderItem    = useCallback(( prop, setProp, index ) => {
        const itemKey = prop.TAG_ID === 0 ? 
            `temp-${prop.TAG_ID}` // Use order as a temporary unique identifier
        : 
            prop.TAG_ID;           // Use the stable ID when available
        return (
            <TagItem
                key={itemKey}
                index={index}
                id={index}
                prop={prop}
                setProp={setProp}
                onDelete={handleItemDelete}
            />
        );
    }, []);

    return (
        <>
            <div className={[MainStyle.row, MainStyle.align_items_center].join(" ")}>
                <div className={MainStyle.col_lg_9}/>
                <div className={MainStyle.col_lg}>
                    <div className={MainStyle.mx_3}>
                        <button
                            style={{width: '100%'}}
                            className={[MainStyle.btn_blue, 
                                        MainStyle.rounded_3, 
                                        MainStyle.border, 
                                        MainStyle.shadow_sm, 
                                        MainStyle.fs_7,
                                        MainStyle.text_white,
                                        MainStyle.py_3,
                                        MainStyle.px_3].join(" ")}
                            onClick={addNewItem}
                        >
                            {GetLabel(appLang, 57)}
                        </button>
                    </div>
                </div>
                <div className={MainStyle.col_lg_1}/>
            </div>
                            
            {/*         Some spacing         */}
            <div className={MainStyle.py_3}/>
                            
            <div className={MainStyle.row}>
                <div className={MainStyle.col_lg_1}/>
                <div className={MainStyle.col_lg_10}>   
                    <div className={MainStyle.my_3}>                 
                        { 
                            mainObject.length > 0 ?
                                mainObject.map((item, i) => renderItem(item, setItem, i)) 
                            :
                        
                            <div className={[ MainStyle.align_items_center, MainStyle.d_flex, MainStyle.justify_content_center].join(" ")}>
                                    <span className={[  MainStyle.fs_6,
                                                        MainStyle.text_body].join(" ")}>
                                        {GetLabel(appLang, 371)}
                                    </span>
                                </div>
                        }
                    </div>  
                </div>  
                <div className={MainStyle.col_lg_1}/>
            </div>
        </>
    );

};

export const UserTagsPage = () => {
    const { showLoader, hideLoader  }       = useLoader();                // Control over the loader
    const { showInfoMessage         }       = useInfoMsgModal();          // Modal message control 
    const [tagList,    setTagList   ]       = useState([]);

    useEffect(() => {
        SetLastFeature(1000);
        const fetchData = async () => {
            try {
                showLoader({logoElement: DefaultLoadingLogo(), loadingMessage: GetLabel(appLang, 0)});
                let fetchedData = await getUserTag();
                if (fetchedData) {
                    if (fetchedData?.status?.statusCode == 0) {
                        if (fetchedData?.response?.content) {
                            fetchedData = fetchedData.response.content;
                            if (fetchedData.length > 0) {
                                for(let i = 0; i < fetchedData.length; i++) {
                                    fetchedData[i].TAG_POSITION = i + 1;
                                    fetchedData[i].IsEditing = false;
                                    fetchedData[i].IsLoading = false;
                                }
                                setTagList(fetchedData);

                            }
                            hideLoader();
                        }
                    }
                    else {
                        hideLoader();
                        showInfoMessage({'header': GetLabel(appLang, 107), 'message': fetchedData.status.message});
                    }
                }                        
            } 
            catch (error) {
                setTagList([]);
            }
        };
        fetchData();
    }, []);
    
    return (
        <>
            <DefaultPadding/>
            <div className={[MainStyle.m_3].join(" ")}>
                <div className={[MainStyle.bg_card, 
                                 MainStyle.shadow, 
                                 MainStyle.border, 
                                 MainStyle.rounded].join(" ")}>
                    <div className={[MainStyle.m_3].join(" ")}>
                        <span className={[MainStyle.fs_5, MainStyle.text_body, MainStyle.fw_semibold].join(" ")}>
                            {GetLabel(appLang, 55)}
                        </span>
                    </div>

                    <div className={[MainStyle.bg_card_inner,
                                     MainStyle.border_top,
                                     MainStyle.border_bottom,
                                     MainStyle.border_end].join(" ")}>
                                    
                        <DefaultPadding/>

                        <div className={MainStyle.row}>
                            <TagList mainObject={tagList} setMainObject={setTagList}/>
                        </div>

                    </div>
                    
                    <div className={MainStyle.my_5}/>

                </div>            
            </div>
        </>
    );
};